import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../../styles/list.css";
import Datatable from "../../components/datatable/Datatable";
import LoadingBox from "../../components/LoadingBox";
import CenterModal from "../../components/modals/CenterModal";
import MessageBox from "../../components/MessageBox";
import Button from "../../components/Button";
import { deleteUser, listUsers, resetUser } from "../../redux/slices/userSlice";
import DeleteItemModal from "../../components/modals/DeleteItemModal";

const UserList = () => {
  const [openModal, setOpenModal] = useState(false);
  const [userId, setUserId] = useState("");

  const userStates = useSelector((state) => state?.listUsers);
  const { users, loading, error, userDeleteSuccess, userUpdateSuccess } =
    userStates;

  const dispatch = useDispatch();

  useEffect(() => {
    if (userDeleteSuccess || userUpdateSuccess) {
      dispatch(resetUser());
    }
    dispatch(listUsers());
  }, [dispatch, userDeleteSuccess, userUpdateSuccess]);

  const deleteUserHandler = (id) => {
    setOpenModal(!openModal);
    setUserId(id);
  };
  const deleteUserAction = () => {
    dispatch(deleteUser(userId));
    setOpenModal(!openModal);
  };
  const updateUserHandler = (id) => {
    "djiod";
  };

  const bulkDelete = (id) => {
    dispatch(deleteUser(id));
  };

  const userColumns = [
    {
      field: "id",
      headerName: "ID",
      width: 80,
      renderCell: (params) => {
        return <div>{params.row._id.substring(16, params.row._id.length)}</div>;
      },
    },
    {
      field: "name",
      headerName: "Name",
      width: 200,
      renderCell: (params) => {
        return (
          <div>
            {params.row.name} {params.row.lastName}
          </div>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      width: 230,
      renderCell: (params) => {
        return <div>{params.row.email}</div>;
      },
    },
    {
      field: "phone",
      headerName: "Phone",
      width: 120,
      renderCell: (params) => {
        return <div>{params.row.phone}</div>;
      },
    },
    {
      field: "isAdmin",
      headerName: "IsAdmin",
      width: 100,
      renderCell: (params) => {
        return <div>{params.row.isAdmin ? "YES" : "NO"}</div>;
      },
    },

    {
      field: "createdAt",
      headerName: "created At",
      width: 100,
      renderCell: (params) => {
        return (
          <div>
            {params.row.createdAt
              ? params.row.createdAt.substring(0, 10)
              : "--"}
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/users/${params.row._id}`}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">View</div>
            </Link>
            <Link
              to={`/users/${params.row._id}/edit`}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">Edit</div>
            </Link>

            <div
              className="deleteButton"
              onClick={() => deleteUserHandler(params.row._id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="list">
      <div className="listContainer">
        {error && <MessageBox variant="danger">{error}</MessageBox>}
        {users?.users?.length > 0 && (
          <Datatable
            title="All Users"
            url={"new"}
            linkText="New user"
            data={users?.users}
            actionColumn={userColumns}
            showCheckBox={true}
            bulkDelete={bulkDelete}
          />
        )}
      </div>
      {loading && (
        <CenterModal
          modalHandler={loading}
          className="bg-transparent text-white"
        >
          <LoadingBox />
        </CenterModal>
      )}

      {openModal && (
        <CenterModal modalHandler={deleteUserHandler}>
          <DeleteItemModal
            action={deleteUserAction}
            modalHandler={deleteUserHandler}
          />
        </CenterModal>
      )}
    </div>
  );
};

export default UserList;
